//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ToastContainer from 'react-bootstrap/ToastContainer';
import Toast from 'react-bootstrap/Toast';

import * as choiceApi from '../../api/choice';
import { Form, Input, TextArea, Label, FormSubmit } from '../../common/form-helpers';

import { SITE_KEY } from '../../App';
import './Contact.scss';


const blankMessage = {
    name: "",
    email: "",
    subject: "",
    body: "",
}

//https://developers.google.com/recaptcha/docs/faq TODO: update formatting of recaptcha text/links to match Google.

export function Contact(props) {
    const [ loadingRecaptcha, setLoadingRecaptcha ] = useState(false);
    const [ showSuccess, setShowSuccess ] = useState(false);
    const [ showError, setShowError ] = useState(false);



    const startingMessage = JSON.parse(sessionStorage.getItem('message')) ?? blankMessage;
    
    const onFieldChange = (fields) => {
        sessionStorage.setItem('message', JSON.stringify(fields));
    }

    const onSubmit = (fields) => {
        setLoadingRecaptcha(true);
        window.grecaptcha.ready(async () => {
            try {
                const token = await window.grecaptcha.execute(SITE_KEY, { action: 'submit' });
                //console.log('sending email', fields, token);
                const resp = await choiceApi.sendContactEmail(fields, token);
                //console.log(resp);
                if (resp.success) {
                    sessionStorage.removeItem('message'); //TODO: uncomment this since it should be here - but for testing, it's nice to comment it out
                    setShowSuccess(true);
                }
                else {
                    setShowError(true);
                }
            }
            catch (error) {
                console.log(error);
            }
            setLoadingRecaptcha(false);
        });
    }


    return (
        <Container className="contact">
            <ToastContainer className="position-fixed top-0 end-0 p-3" style={{ zIndex: 11 }}>
                <Toast show={showSuccess} bg="primary" onClose={() => setShowSuccess(!showSuccess)} delay={10000} autohide>
                    <Toast.Header>
                        <strong className="me-auto">Message Sent</strong>
                        <small>Just Now</small>
                    </Toast.Header>
                    <Toast.Body>We will get back to you soon!</Toast.Body>
                </Toast>
            </ToastContainer>

            <ToastContainer className="position-fixed top-0 end-0 p-3" style={{ zIndex: 11 }}>
                <Toast show={showError} bg="danger" onClose={() => setShowError(!showError)} delay={10000} autohide>
                    <Toast.Header>
                        <strong className="me-auto">Unable to Send Message</strong>
                        <small>Just Now</small>
                    </Toast.Header>
                    <Toast.Body>Please try again!</Toast.Body>
                </Toast>
            </ToastContainer>

            <h1>Contact Us</h1>

            <p>
                Please check our <Link to="/faq">FAQ</Link> for answers to the most popular questions. 
                If you still cannot find what you are looking for, please contact us. 
                We generally respond to emails a few evenings during the week and the day of parties.
                We generally return phone calls the day of and day before events.
            </p>

            <h2>E-Mail</h2>
                
            <p>
                Before you email us, please look to see if we've answered your question in our <Link to="/faq">FAQ</Link>. 
                Also, please include your email and/or phone number in the body of your message in case you have a typo on the email line - otherwise we won't have a way to get back in touch with you!
            </p>

            <Form className="ifta-form dark" initial={startingMessage} getList={choiceApi.getLookup} onFieldChange={onFieldChange}>
                <Row>
                    <Col xs={12} md={6}>
                        <Input name="name" />
                        <Label name="name">Name</Label>
                    </Col>
                    <Col xs={12} md={6}>
                        <Input name="email" />
                        <Label name="email">Email</Label>
                    </Col>
                    <Col xs={12}>
                        <Input name="subject" />
                        <Label name="subject">Subject</Label>
                    </Col>
                    <Col xs={12}>
                        <TextArea name="body" rows={8}/>
                        <Label name="body">Body</Label>
                    </Col>
                </Row>

                <Row>
                    <Col xs={{offset: 8, span: 4}} lg={{offset: 10, span: 2}} className="text-end">
                        <FormSubmit as={Button} disabled={loadingRecaptcha} ignoreDirty onClick={onSubmit}> 
                            {loadingRecaptcha ? 'Sending...' : 'Send'}
                        </FormSubmit>
                    </Col>
                </Row>
            </Form>

            <h2>Phone</h2>
            <p>
                <a href="tel:4012743700">(401) 274-3700</a> - We try to staff the phones a few times a week, usually the day of an event. Thank you for your patience!
            </p>



        </Container>
    );
}
